import { useTranslation } from "react-i18next";
import {
  BottomBox,
  BottomList,
  BottomTextBox,
  Container,
  MainBox,
  MainList,
  MainTextBox,
  MainTop,
  TopBox,
  TopNav,
  Wrapper,
} from "./style";
import { useState } from "react";
import Nav1 from "../Nav1";
import Nav4 from "../Nav4";
import Nav2 from "../Nav2";
import Nav3 from "../Nav3";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
const Com2 = ({ t }) => {
  const [select, setSelect] = useState(0);
  const topNav = [t("2-1"), t("2-2"), t("2-3"), t("2-4")];
  const language = useSelector(selectLanguage);
  return (
    <Container>
      <span>{t("2-5")}</span>
      <Wrapper>
        <TopBox>
          {topNav.map((menu, idx) => (
            <TopNav onClick={() => setSelect(idx)} isSelected={select === idx} key={idx}>
              {menu}
            </TopNav>
          ))}
        </TopBox>
        {select === 0 ? <Nav1 t={t} /> : select === 1 ? <Nav2 t={t} /> : select === 2 ? <Nav3 t={t} /> : <Nav4 t={t} />}
        <BottomBox language={language}>
          <BottomTextBox>
            <span>{t("2-6")}</span>
            <BottomList>
              <div>
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
                  alt=""
                />
                <span>{t("2-7")}</span>
              </div>
              <div>
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
                  alt=""
                />
                <span>{t("2-8")}</span>
              </div>
              <div>
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
                  alt=""
                />
                <span>{t("2-9")}</span>
              </div>
            </BottomList>
          </BottomTextBox>
          <BottomTextBox>
            <span>{t("2-10")}</span>
            <BottomList>
              <div>
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
                  alt=""
                />
                <span>
                  <span>{t("2-11")}</span>
                  <span>{t("2-12")}</span>
                </span>
              </div>
              <div>
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
                  alt=""
                />
                <span>
                  <span>{t("2-13")}</span>
                  <span>{t("2-14")}</span>
                </span>
              </div>
              <div>
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
                  alt=""
                />
                <span>
                  <span>{t("2-15")}</span>
                  <span>{t("2-16")}</span>
                </span>
              </div>
            </BottomList>
          </BottomTextBox>
        </BottomBox>
      </Wrapper>
    </Container>
  );
};

export default Com2;
